import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Attendance, AttendanceCreate, AttendanceFilter } from '../data/attendance';

export function createAttendanceService(client: AxiosInstance) {
  return createCrudService<Attendance, AttendanceCreate, AttendanceFilter>(client, "/hrm/Attendance", "attendanceId");
}

export type AttendanceService = CrudService<Attendance, AttendanceCreate, AttendanceFilter>;
